import { saveFile } from '@modules/file-menagement/fileUtils';
import { DriveRequests } from 'src/requests/drive';
import { create } from 'zustand';
import type { DownloadState } from './types';

export const downloadDriveStoreFactory = () =>
  create<DownloadState>((set, get) => ({
    loadingMap: {},
    progressMap: {},

    downloadContent: async (file, downloadUrl) => {
      const id = file._id;
      set((s) => ({
        loadingMap: { ...s.loadingMap, [id]: true },
        progressMap: { ...s.progressMap, [id]: 0 },
      }));

      try {
        const url = downloadUrl ?? (await DriveRequests.getDownloadUrl(id)).url;
        const res = await fetch(url);
        if (!res.ok || !res.body) throw new Error('Failed to fetch file');

        const total = Number(res.headers.get('Content-Length')) || 0;
        const reader = res.body.getReader();
        let received = 0;
        const chunks: Uint8Array[] = [];

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          if (value) {
            chunks.push(value);
            received += value.length;
            if (total) {
              const pct = Math.round((received / total) * 100);
              set((s) => ({ progressMap: { ...s.progressMap, [id]: pct } }));
            }
          }
        }

        const blob = new Blob(chunks);
        saveFile(file.name, URL.createObjectURL(blob));
      } catch (error) {
        console.error('download error', error);
      } finally {
        set((s) => ({
          loadingMap: { ...s.loadingMap, [id]: false },
          progressMap: { ...s.progressMap, [id]: 0 },
        }));
      }
    },

    resetFor: (fileId) => {
      set((s) => ({
        loadingMap: { ...s.loadingMap, [fileId]: false },
        progressMap: { ...s.progressMap, [fileId]: 0 },
      }));
    },
  }));
